import { Component, ElementRef, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";

import {
	GlobalDataOpsService,
	GlobalDomOpsService,
	AcepSSOService
} from "@acepteam/globalspack";
import { DomService, DataService, LoggerService } from "./core/services";
import {
	Router,
	ActivatedRoute,
	NavigationStart,
	NavigationEnd
} from "@angular/router";
import {
	MemberAppDataService,
	MemberAppDomService
} from "./memberapp/services";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent {
	private subscriptions: Array<Subscription> = [];
	hideNavigation: boolean = false;
	pageTitle: string = "Loading...";

	csspath: string = '';
	@ViewChild("acepMaster") acepMaster: ElementRef;
	env: string = environment.env;
	ssoUser: any = "";

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private globalDataOpsService: GlobalDataOpsService,
		private globalDomOpsService: GlobalDomOpsService,
		private _ssoService: AcepSSOService,
		private dataService: DataService,
		private domService: DomService,
		private loggerService: LoggerService,
		private memberAppDataService: MemberAppDataService,
		private memberAppDomService: MemberAppDomService
	) {
		this.globalDomOpsService.showwait();

		this.csspath = `${this.globalDataOpsService.BasePath}/globalstyles/css/${this.globalDataOpsService.ORG}.css`;


		//Subscriptions
		let routerEventsSubscription: Subscription = this.router.events.subscribe(
			event => {
				if (event instanceof NavigationStart) {
					//console.log('NavigationEnd:', event);

					if (event.id == 1) {
						//it means this is the first page laoded//
						//in this case there should be no animation in routing on page
						//this.dataservice.navigationDirection = "";
					}
				} else if (event instanceof NavigationEnd) {
					//this.routename = this.router.url.replace('/', '');
					this.dataService.routename = event.url.replace("/", "");
					this.pageTitle = "Membership Application";


					if (this.dataService.IsRetirementApplication ||
						this.dataService.IsLobbyPage ||
						this.dataService.IsSectionApplication) {


						if (this.dataService.IsRetirementApplication) {
							this.pageTitle = "Retiring Members Form";
						}
						else if (this.dataService.IsSectionApplication) {
							this.pageTitle = this._ssoService.isacepmember ? "Join a Section" : "Subscribe to a Section";
						}

						this.hideNavigation = true;
					}
					//this.loggerService.logInfo(`ROUTE NAME - ${this.dataService.routename}`);
					if (!this.hideNavigation) {
						this.memberAppDomService.updatesummaryVisibility(
							false,
							this.dataService.routename,
							this.memberAppDataService.memberAppData
						);
					}
					//GOOGLE ANALYTICS
					// this.globalDataOpsService.InjectAnalytics(event.urlAfterRedirects);
				}
			}
		);



		this._ssoService.getMessage().subscribe(message => {
			// this.username = message.context.FirstName;
			// this.avatar = message.context.Avatar;
			let con = message.context;
			this.ssoUser = JSON.stringify({
				acepid: con.ContactNumber,
				firstName: con.FirstName,
				avatar: con.Avatar,
				loginUI_ExpiryDate: con.LoginUI_ExpiryDate,
				loginUI_Join: con.LoginUI_Join
			});


			if (!!!this.acepMaster.nativeElement.ssouser) {
				this.acepMaster.nativeElement.setAttribute("ssouser", this.ssoUser);
			}


			//this.loginheader.user = this.user;
		});


	}

	logout() {
		this._ssoService.showwait();
		this._ssoService.logout();
	}
}
